<template>
<div class="content">
    <h1 class="page-title" v-if="response && !response.success">Waiting for response ...</h1>
    <h1 class="page-title" v-if="response && response.success">Your registration is now confirmed.</h1>
    <div class="response glass-element">
        <h3>response:</h3>
        <h3 v-if="response && response.success">Registration completed, you can now <router-link to="/login">Login</router-link>
        </h3>
        <Loader v-if="loading" />
    </div>

    <div>
        <v-btn @click="showForm = !showForm">Try again...</v-btn>
        <p v-if="formResponse"> {{formResponse.data.message}}</p>
        <v-form inline v-if="showForm" @submit.stop.prevent="resendConfirmationEmail">

            <label class="sr-only" for="inline-form-input-email">E-mail</label>
            <v-form-input id="inline-form-input-email" v-model="email" type="email" placeholder="Enter email" required></v-form-input>

            <v-btn type="submit" variant="primary">Resend confirmation e-mail</v-btn>
        </v-form>
    </div>
</div>
</template>

<script>
import {
    httpRequest
} from "@/services";
import Loader from "@/components/atoms/Loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            loading: false,
            response: null,
            showForm: false,
            email: null,
            formResponse: null,
        };
    },
    methods: {
        async confirmEmail() {
            this.loading = true;
            this.response = null;
            this.response = await httpRequest(
                "post",
                "rest-auth/registration/verify-email/", {
                    key: this.$route.params.token
                }
            );
            this.loading = false;
        },
        async resendConfirmationEmail() {
            // /registration/resend-email/
            this.loading = true;
            this.formResponse = null;
            this.formResponse = await httpRequest(
                "post",
                "rest-auth/registration/resend-email/", {
                    email: this.email
                }
            );
            this.loading = false;
        }
    },
    mounted() {
        this.confirmEmail();
    },
};
</script>

<style scoped>
.content {
    margin: 100px;
}

.response {
    padding: 12px 24px;
}

button {
    margin: 42px 0;
}
</style>
